import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalEventsService {
    constructor() {}

    public isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    public isAuthenticated$: Observable<boolean> = this.isAuthenticated.asObservable();

    public branding: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public branding$: Observable<any> = this.branding.asObservable();

    public hasAk: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public hasAk$: Observable<any> = this.hasAk.asObservable();

    public hasCabinet: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public hasCabinet$: Observable<any> = this.hasCabinet.asObservable();

    public logo: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    public logo$: Observable<string> = this.logo.asObservable();

    public bookingTypes: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public bookingTypes$: Observable<any> = this.logo.asObservable();

    setIsAuthenticated(isAuthenticated: boolean) {
        this.isAuthenticated.next(isAuthenticated);
    }

    getIsAuthenticated(): boolean {
        return this.isAuthenticated.getValue();
    }

    getBranding(): any {
        return this.branding.getValue();
    }

    setBranding(branding: any) {
        this.branding.next(branding);
    }

    getHasCabinet(): any {
        return this.hasCabinet.getValue();
    }

    setHasCabinet(hasCabinet: any) {
        this.hasCabinet.next(hasCabinet);
    }

    getHasAk(): any {
        return this.hasAk.getValue();
    }

    setHasAk(hasAk: any) {
        this.hasAk.next(hasAk);
    }

    getLogo(): any {
        return this.logo.getValue();
    }

    setLogo(logo: any) {
        this.logo.next(logo);
    }

    getBookingTypes() {
        return this.bookingTypes.getValue();
    }

    setBookingTypes(bookingTypes: any) {
        this.bookingTypes.next(bookingTypes);
    }
}
